<template>
  <div class="input-component" :style="getStyle" :data-name="options.name || options.menuName">
    <input
      v-if="getIconPosition === 'right'"
      :type="inputTypeVal"
      :placeholder="placeholder"
      :style="getIptStyle"
      v-model="inputValue"
      :readonly="readonly"
    />
    <!-- <span v-if="iconType === 'icon' && iconSrc" :class="iconSrc" :style="getIconStyle"></span> -->
    <cxIcon v-if="iconType === 'icon' && iconSrc" :options="options" :iconStyle="getIconStyle"></cxIcon>
    <img v-else-if="iconType === 'img' && iconSrc" :src="iconSrc" :style="getIconImgStyle" />
    <input
      v-if="getIconPosition === 'left'"
      :type="inputTypeVal"
      :placeholder="placeholder"
      :style="getIptStyle"
      v-model="inputValue"
      :readonly="readonly"
    />
    <i class="icon-del icon-portal-close-one" @click="delClick" v-if="inputValue && showDelIcon"></i>
  </div>
</template>

<script>
import eventMixin from "utils/event/eventMixin.js"
import { isSsrPage } from "utils/index"
import { findLayoutOptions } from "utils"

export default {
  mixins: [eventMixin],
  name: "cxInput",
  props: {
    options: {
      type: Object,
      default: null
    },
    myid: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      iconContent: "",
      isFlag: false
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    getStyle() {
      let borderW = ""
      this.checkAndSetVal(this.options, "borderWidth", "borderWidth", 1)
      if (Array.isArray(this.options.borderWidth)) {
        this.options.borderWidth.forEach(item => [(borderW += ` ${item}px`)])
      } else {
        borderW += ` ${this.options.borderWidth}px`
      }
      if(this.options.showBorder === false){
        borderW = 0
      }
      return {
        ...this.bgStyle,
        // todo skew 是什么情况
        // width: this.options.skew != 0 ? parseInt(this.options.width / 2) + "px" : this.options.width + "px",
        width: "100%",
        // height: this.options.height + "px",
        height: "100%",
        opacity: this.options.opacity / 100,
        "box-shadow": this.boxShadowStyle,
        padding: this.getPaddingStyle,
        "border-top-left-radius": this.options.borderTopLeftRadius + "px",
        "border-top-right-radius": this.options.borderTopRightRadius + "px",
        "border-bottom-right-radius": this.options.borderBottomRightRadius + "px",
        "border-bottom-left-radius": this.options.borderBottomLeftRadius + "px",
        "border-style": this.options.borderStyle,
        // "border-color": this.options.borderIsThemeColor
        //   ? this.themeColor
        //   : this.options.borderColor.color
        //   ? this.options.borderColor.color
        //   : this.options.borderColor,
        "border-color": this.$parseColor(this.options.borderColor, {
          isThemeColor: this.options.borderIsThemeColor
        }),
        "border-width": borderW
      }
    },
    getTextStyle() {
      const lineHeight = this.options.lineHeightType === '%' ? (this.options.lineHeight / 100) :
          this.options.lineHeightType === 'normal'? "normal" :this.options.lineHeight + "px"
      return {
        "--placeHolderFontSize": this.options.placeHolderFontSize + "px",
        // "--placeHolderFontColor": this.options.placeHolderFontColor,
        "--placeHolderFontColor": this.$parseColor(this.options.placeHolderFontColor),
        "--placeHolderFontWeight": this.options.placeHolderFontWeight,
        "--placeHolderFontFamily": this.options.placeHolderFontFamily,
        "font-family": this.options.fontFamily,
        "font-size": this.options.fontSize + "px",
        "font-weight": this.options.fontWeight,
        "font-style": `${this.options.fontStyle}`,
        "text-decoration": this.options.textDecoration,
        // "line-height": `${this.options.lineHeight}px`,
        // "letter-spacing": this.options.letterSpacing + "px",
        "line-height": lineHeight,
        "letter-spacing":
          this.options.letterSpacingType === "%"
            ? this.options.letterSpacing / 100 + "em"
            : this.options.letterSpacing + "px",
        "writing-mode": this.options.writingMode,
        "text-align": this.options.textAlign,
        // color: this.options.textIsThemeColor
        //   ? this.themeColor
        //   : this.options.color && this.options.color.color
        //   ? this.options.color.color
        //   : this.options.color
        "color": this.$parseColor(this.options.color, {
          isThemeColor: this.options.textIsThemeColor
        }),
      }
    },
    bgStyle() {
      let containerBg = {
        backgroundImage: ""
      }
      let curBackground = this.options.background
      if (
        !curBackground ||
        !Array.isArray(curBackground) ||
        (Array.isArray(curBackground) && curBackground.length === 0)
      ) {
        curBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.hasOwnProperty("bgColorIsThemeColor") ? this.options.bgColorIsThemeColor : false,
            color: this.options.bgColor
          }
        ]
      }
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},${bg.clipSize}`:`${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},${bg.alignType}`:`${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},${bg.repeatType}`:`${bg.repeatType}`
            break
          case "color":
            // containerBg.backgroundColor = bg.isThemeColor
            //   ? this.$store.state[this.request_prefix].page.themeColor
            //   : bg.color
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                tmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},auto`:`auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},center`:`center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},no-repeat`:`no-repeat`
            }
            break
          case "radialGradient":
            let radialTmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage +=
              //   dot + "radial-gradient(at " + bg.data.siteX + "% " + bg.data.siteY + "%," + radialTmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},auto`:`auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},center`:`center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},no-repeat`:`no-repeat`
            }
            break
          default:
        }
      })
      return containerBg
    },
    boxShadowStyle() {
      let tmpStyle = ""
      let _this = this
      if (Array.isArray(this.options.boxShadowH)) {
          this.options.boxShadowH.forEach((item, index) => {
            if (index > 0) {
              tmpStyle += ","
            }
            // tmpStyle += `${_this.options.boxShadowH[index]}px ${_this.options.boxShadowV[index]}px ${_this.options.boxShadowBlur[index]}px ${_this.options.boxShadowSpread[index]}px ${_this.options.boxShadowColor[index]}`
            tmpStyle += `${_this.options.boxShadowH[index]}px ${_this.options.boxShadowV[index]}px ${_this.options.boxShadowBlur[index]}px ${_this.options.boxShadowSpread[index]}px ${_this.$parseColor(_this.options.boxShadowColor[index])}`
          })
        } else {
          // tmpStyle += `${this.options.boxShadowH}px ${this.options.boxShadowV}px ${this.options.boxShadowBlur}px ${this.options.boxShadowSpread}px ${this.options.boxShadowColor}`
          tmpStyle += `${this.options.boxShadowH}px ${this.options.boxShadowV}px ${this.options.boxShadowBlur}px ${this.options.boxShadowSpread}px ${this.$parseColor(this.options.boxShadowColor)}`
        }
      return tmpStyle
    },
    getIptStyle() {
      return {
        ...this.getTextStyle,
        "background-color": "transparent",
        width: this.getIptWidth,
        // height: this.options.height + "px"
        // width: "100%",
        height: "100%"
      }
    },
    iconSrc() {
      return this.options ? this.options.iconSrc : ""
    },
    iconType() {
      return this.options ? this.options.iconType : "img"
    },
    getIconPosition() {
      return this.options ? this.options.iconPosition : "left"
    },
    getMargin() {
      return this.options.iconPosition === "left"
        ? `0 ${this.options.iconMargin}px 0 0`
        : `0 0 0 ${this.options.iconMargin}px`
    },
    getIconStyle() {
      return {
        display: "inline-block",
        // "--color": this.options.iconColorIsThemeColor
        //   ? this.themeColor
        //   : this.options.iconColor.color
        //   ? this.options.iconColor.color
        //   : this.options.iconColor,
        "--color": this.$parseColor(this.options.iconColor, {
          isThemeColor: this.options.iconColorIsThemeColor
        }),
        fontSize: this.options.iconWidth + "px",
        height: this.options.iconWidth + "px",
        width: this.options.iconWidth + "px",
        margin: this.getMargin,
        "vertical-align": "middle"
      }
    },
    getIconImgStyle() {
      return {
        display: "inline-block",
        "vertical-align": "middle",
        width: this.options.iconWidth + "px",
        margin: this.getMargin
      }
    },
    getPaddingStyle() {
      let padding = `${this.options.padding}px`
      if (!this.options.textPaddingTypeFlag || this.options.textPaddingTypeFlag === 2) {
        padding = ` ${this.options.paddingTop}px  ${this.options.paddingRight}px  ${this.options.paddingBottom}px  ${this.options.paddingLeft}px`
      }
      return padding
    },
    themeColor() {
      return isSsrPage() ? this.$store.state.page.themeColor : this.$store.state[this.request_prefix].page.themeColor
    },
    placeholder: {
      get() {
        return this.options.placeholder ? this.options.placeholder : ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "placeholder", false, null, this.myid)
      }
    },
    inputValue: {
      get() {
        return this.options.inputValue
      },
      set(newVal) {
        let tmpData = JSON.parse(JSON.stringify(this.options))
        tmpData.inputValue = newVal
        const param = {
          ...this.myid,
          options: tmpData
        }
        this.$store.dispatch(this.request_prefix + "/changeAllOptions", param)
      }
    },
    inputTypeVal() {
      return this.options.inputTypeVal ? this.options.inputTypeVal : ""
    },
    getIptWidth() {
      let padding = this.options.padding
        ? this.options.padding * 2
        : this.options.paddingLeft || this.options.paddingRight
        ? this.options.paddingLeft + this.options.paddingRight
        : 0
      let margin = this.iconSrc ? this.options.iconMargin : 0
      let iconWidth = this.iconSrc ? this.options.iconWidth : 0
      let width = `calc(100% - ${iconWidth + margin}px)`
      return this.options.widthType === "%" ? width : this.options.width - (iconWidth + margin + padding + 10) + "px"
    },
    readonly() {
      return this.options.readonly ? this.options.readonly : false
    },
    showDelIcon() {
      return this.options.showDelIcon ? this.options.showDelIcon : false
    },
    dataType() {
      // 1:本地数据 3: 搜索数据
      return this.options.dataType || "1"
    },
    layoutOptions() {
      return findLayoutOptions(this, this.myid)
    },
    searchComponentPlugin() {
      return this.layoutOptions?.pluginName?.includes("searchComponentPlugin")
    },
  },
  watch: {
  //   iconSrc: {
  //     immediate: true,
  //     handler: function (n, o) {
  //       if (!!n) {
  //         let contextPath = window.hasOwnProperty("p_contextpath") ? window["p_contextpath"] : ""
  //         this.instance.get(contextPath + `v2/svg/${n}`).then(res => {
  //           if (res.status === 200) {
  //             this.iconContent = res.data
  //           }
  //         })
  //       }
  //     }
  //   }
    dataType(n, o) {
      if (n !== o && n === "3" && !this.isFlag) {
        this.watchSearchData()
      }
    }
  },
  mounted() {
    if (this.dataType === "3") {
      this.watchSearchData()
    }
  },
  methods: {
    watchSearchData() {
      this.isFlag = true
      this.$eventBus.$on(`searchDataUpdate-${this.myid.container_id}-${this.myid.rect_id}`, (data)=> {
        const { type, activeData } = data
        if (type === 0) {
          console.log('activeData :>>',activeData);
          this.setSearchData(activeData)
        }
      })
    },
    async updateData() {},
    checkAndSetVal(opt, key, optname, val) {
      //兼容为NaN或没有的数值数据
      if (!opt.hasOwnProperty(key) || opt[key] !== opt[key] || opt[key] === null || opt[key] === undefined) {
        this.$changeOptionsEV(val, optname, false, null, this.myid)
        return val
      }
    },
    delClick() {
      this.inputValue = ""
    },
    setSearchData(data) {
      this.placeholder = data && data.linkDes ? data.linkDes : this.options?.emptyDataShowLocal ? this.options?.emptyPlaceholder : ""
    }
  },
  beforeDestroy() {
    this.$eventBus.$off(`searchDataUpdate-${this.myid.container_id}-${this.myid.rect_id}`)
  }
}
</script>

<style scoped>
::v-deep.input-component span {
  display: inline-block;
}
::v-deep.input-component svg {
  vertical-align: top;
  width: 100%;
  height: 100%;
}
::v-deep.input-component svg * {
  stroke: var(--color);
}
::v-deep.input-component input::placeholder {
  /* WebKit browsers*/
  color: var(--placeHolderFontColor) !important;
  font-size: var(--placeHolderFontSize) !important;
  font-family: var(--placeHolderFontFamily) !important;
  font-weight: var(--placeHolderFontWeight) !important;
}
.input-component .icon-del {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  font-size: 16px;
}
.input-component .icon-del::before {
  color: rgba(0, 0, 0, 0.4);
}
</style>
